import { Outlet } from "react-router";
import { useAmendmentsSocket } from "../../hooks/socket/use-amendments-socket";
import { useProposalsSocket } from "../../hooks/socket/use-proposals-socket";

export default function ActuarialLayout() {
    useAmendmentsSocket();
    useProposalsSocket();
    return <Outlet />;
}